import React, { useState } from "react";
import { Modal } from "@linkfluence/core/modal";
import Perso from "@linkfluence/core/profile/perso";
import { User } from "@linkfluence/models/user";
import Profile, { Tab } from "@ui-kit/profile";
import Access from "@ui-kit/profile/access";
import Custo from "@ui-kit/profile/custo";
import Security from "@ui-kit/profile/security";
import { useFeature } from "@radarly/core/features/use-cases";
import {
  useCurrentUser,
  useCurrentUserLocale,
  useCurrentUserProducts,
} from "../user/use-cases";
import LogoutConfirmation from "./logout";

const MODAL_LOGOUT_CONFIRMATION = "modalLogoutConfirmation";

export interface IProps {
  onClose: () => void;
  disabledMode?: boolean;
  accessPanel?: React.ReactNode;
  projects?: any;
  onUpdateUser: (user: Partial<User>) => void;
  onResetPassword: () => void;
}

const CoreProfile = ({
  onClose,
  disabledMode,
  accessPanel,
  projects,
  onUpdateUser,
  onResetPassword,
}: IProps) => {
  const [tab, setTab] = useState(Tab.Informations);
  const locale = useCurrentUserLocale();
  const products = useCurrentUserProducts();
  const user = useCurrentUser();
  const allowLocaleDebug = useFeature("locale_debug");
  const { open, close, ModalWrapper } = Modal.get(MODAL_LOGOUT_CONFIRMATION);

  return (
    <>
      <Profile
        user={user}
        onLogout={() => open()}
        onChangeTab={setTab}
        onClose={onClose}
        tab={tab}
      >
        {tab === Tab.Informations && <Perso onUpdateUser={onUpdateUser} />}
        {tab === Tab.Access && (
          <Access locale={locale} products={products} projects={projects}>
            {accessPanel}
          </Access>
        )}
        {tab === Tab.Customization && (
          <Custo
            user={user}
            onUpdateUser={onUpdateUser}
            disabledMode={disabledMode}
            allowLocaleDebug={allowLocaleDebug}
          />
        )}
        {tab === Tab.Security && (
          <Security
            locale={locale}
            authentication={user.authentication}
            onResetPassword={onResetPassword}
          />
        )}
      </Profile>
      <ModalWrapper>
        <LogoutConfirmation onClose={() => close()} />
      </ModalWrapper>
    </>
  );
};

export default CoreProfile;
